import { render, staticRenderFns } from "./AdminPoliciesView.vue?vue&type=template&id=a1551df4&scoped=true&"
import script from "./AdminPoliciesView.vue?vue&type=script&lang=ts&"
export * from "./AdminPoliciesView.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPoliciesView.vue?vue&type=style&index=0&id=a1551df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1551df4",
  null
  
)

export default component.exports